"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _defaultErrorBoundary = _interopRequireWildcard(require("./components/defaultErrorBoundary"));

Object.keys(_defaultErrorBoundary).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultErrorBoundary[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _defaultErrorBoundary[key];
    }
  });
});

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _index = require("./util/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var errorboundary = function errorboundary() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$Boundary = _ref.Boundary,
      Boundary = _ref$Boundary === void 0 ? _defaultErrorBoundary["default"] : _ref$Boundary,
      _ref$BoundaryProps = _ref.BoundaryProps,
      BoundaryProps = _ref$BoundaryProps === void 0 ? {} : _ref$BoundaryProps;

  return function (InnerComponent) {
    if (Boundary && !Boundary.prototype.isReactComponent) {
      console.warn("The ".concat(Boundary, " component is not a react component"));
      Boundary = _defaultErrorBoundary["default"];
    }

    if (Boundary && !(Boundary.prototype.componentDidCatch || Boundary.prototype.getDerivedStateFromError)) {
      console.warn("".concat(Boundary, " doesn't has componentDidCatch or getDerivedStateFromError"));
      Boundary = _defaultErrorBoundary["default"];
    } // 将React.memo包裹过的组件转换成普通函数式组件


    if (!(0, _index.isComponentClass)(InnerComponent) && (0, _index.isReactMemo)(InnerComponent)) {
      var NewComponent = InnerComponent;

      InnerComponent = function InnerComponent(props) {
        return /*#__PURE__*/React.createElement(NewComponent, props);
      };
    }

    var WrapperComponent = /*#__PURE__*/function (_Component) {
      _inherits(WrapperComponent, _Component);

      var _super = _createSuper(WrapperComponent);

      function WrapperComponent() {
        _classCallCheck(this, WrapperComponent);

        return _super.apply(this, arguments);
      }

      _createClass(WrapperComponent, [{
        key: "render",
        value: function render() {
          var forwardedRef = this.props.forwardedRef;
          return /*#__PURE__*/React.createElement(Boundary, BoundaryProps, (0, _index.isComponentClass)(InnerComponent) ? /*#__PURE__*/React.createElement(InnerComponent, _extends({}, this.props, {
            ref: forwardedRef
          })) : /*#__PURE__*/React.createElement(InnerComponent, this.props));
        }
      }]);

      return WrapperComponent;
    }(React.Component);

    var NewErrorBoundary = (0, React.forwardRef)(function (props, ref) {
      return /*#__PURE__*/React.createElement(WrapperComponent, _extends({
        forwardedRef: ref
      }, props));
    });
    (0, _hoistNonReactStatics["default"])(NewErrorBoundary, InnerComponent);
    return NewErrorBoundary;
  };
};

var _default = errorboundary;
exports["default"] = _default;